import { ADModalBody, ADModalFooter, AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal";
import { useWindowContext } from "src/WindowManager/useWindowContext";
import { closeWindow, ManagedWindow } from "src/WindowManager/WindowState";
import { GlassButton, GlassButtonRow } from "./GlassButtons";
import { GICButton, GlassInputControl, GlassInputGroup, GlassInputGroupTitle, GlassTextInputTransformer } from "./GlassInput";
import { useContext, useEffect, useRef, useState } from "react";
import { actionSetMapInteractionState, MapInteractionState, MapitStateContext } from "src/states/MapitState";
import { MitLatLng } from "src/managers/MapFacade";
import { PropertyInfoInterface } from "src/managers/PropertyInfoInterface";
import { message } from "./Message";
import { Spinner } from "react-bootstrap";
import jsPDF, { AcroFormTextField } from "jspdf";
import { MitStorage } from "src/managers/MitStorage";
import { ActionTracker } from "src/common/managers/ActionTracker";
import { MIBIcon } from "src/componentsUtils/MIBIcon";

export function ServitutErklaering(props: { managedWindow: ManagedWindow }) {
   const { dispatch: windowDispatch } = useWindowContext()
   const { state: mapitState, dispatch: mapitDispatch } = useContext(MapitStateContext);

   const [selectFromMap, setSelectFromMap] = useState<boolean>(false);
   const [bfeNr, setBfeNr] = useState<string>("");
   const [Journalnr, setJournalnr] = useState<string>(props.managedWindow.windowParams?.journalnr || "");
   const [loadingServitut, setLoadingServitut] = useState<boolean>(false);
   const hrefRef = useRef<HTMLAnchorElement | null>(null);
   const [servitutter, setServitutter] = useState<servitut[]>([]);
   const [ejendomsData, setEjendomsData] = useState<any>(undefined)
   const [delNrList, setDelNrList] = useState<{ nr: string, areal: string }[]>([{ nr: "", areal: "" }, { nr: "", areal: "" }]);
   const [Underskrift, _setUnderskrift] = useState<{
      navn: string,
      title: string,
      underskrift: File | null
   }>({ ...MitStorage.getValue<{ navn: string, title: string }>("ServitutUnderskrift") ?? { navn: "", title: "" }, underskrift: null });

   function setUnderskrift(value: { navn: string, title: string, underskrift: File | null }) {
      MitStorage.setValue("ServitutUnderskrift", { navn: value.navn, title: value.title });
      _setUnderskrift(value);
   }

   useEffect(() => {
      if (selectFromMap) {
         mapitDispatch(actionSetMapInteractionState(MapInteractionState.Override))
         const handleMapClick = async (e) => {
            let x = await PropertyInfoInterface.getSFEFromPoint(MitLatLng.fromM(e.lngLat))
            if (x.BFEnummer) {
               setBfeNr(x.BFEnummer);
               setSelectFromMap(() => false)
            } else {
               message.error("Ingen Bfe fundet på det valgte punkt");
            }
         }
         mapitState.map?.on("click", handleMapClick);
         return () => {
            mapitState.map?.off("click", handleMapClick);
            mapitDispatch(actionSetMapInteractionState(MapInteractionState.Normal))
         }
      }
   }, [selectFromMap]);

   useEffect(() => {
      setEjendomsData([]);
      setServitutter([]);
   }, [bfeNr]);

   async function hentDataOgServitutter(bfe: string) {
      setLoadingServitut(true);
      await Promise.all([
         PropertyInfoInterface.getDataTingbogByBFE(bfe).catch(() => {
            throw "Fejl ved hentning af servitutter fra Tinglysningen";
         }).then((data) => {
            if (data?.servitutter) {
               setServitutter(data.servitutter);
            } else {
               throw "Ingen servituter fundet for det angivne BFE.";
            }
         }),
         PropertyInfoInterface.LookupByBFE(bfe).catch(() => {
            throw "Fejl ved hentning af matrikler fra Datafordeleren";
         }).then((data) => {
            if (data) {
               let transformedData = transFormToEjendomsData(data, bfe);
               if (transformedData.length === 0) {
                  throw "Ingen Matrikler fundet, er dette en SFE?";
                  return
               }
               setEjendomsData(transformedData);
            } else {
               throw "Ingen data fundet for det angivne BFE.";
            }
         })
      ]).catch((err: string) => {
         message.error(err);
      })
      setLoadingServitut(false);
   }

   // function opretNytJournalnr() {

   //    PropertyInfoInterface.sfeLookupByBfeNr(parseInt(bfeNr)).then(async (result) => {
   //       const sfe = await result.json();
   //       console.log("SFE Lookup Result:", sfe);
   //    });

   // }

   function handleDelNrLength(length: number) {
      setDelNrList((prev) => {
         if (length < prev.length) {
            return prev.slice(0, length);
         } else {
            let next = [...prev];
            while (next.length < length) {
               let nextNr = Math.max(...next.map((a) => { let n = parseInt(a.nr); return isNaN(n) ? -1 : n })) + 1 || ""
               next.push({ nr: nextNr.toString() || "", areal: "" });
            }
            return next;
         }
      });
   }

   return (
      <AdvancedDragModal window={props.managedWindow}
         onClose={() => windowDispatch(closeWindow(props.managedWindow.id))} title={"Servituterklæring"}
         PosDefault={{ left: "60px", top: "60px" }}
      >
         {/* <ADModalInfo >
            Early preview, 
         </ADModalInfo> */}
         <ADModalBody >
            <GlassInputGroup>
               <GlassTextInputTransformer label={"Ejendom SFEnr."} >
                  <GlassInputControl>
                     <a ref={hrefRef} />
                     <input value={bfeNr} onChange={(e) => setBfeNr(parseInt(e.target.value).toString())} type="text" />
                     <GICButton title="Vælg ved klik på kortet" className={selectFromMap ? "active" : ""} onClick={() => { setSelectFromMap((a) => !a) }}><MIBIcon icon="point" /></GICButton>
                  </GlassInputControl>
               </GlassTextInputTransformer>
               {selectFromMap && <><span></span><div style={{ fontSize: "15px", textAlign: "center", color: "orange" }}>Vælg ejendom ved klik på kortet</div></>}
               <GlassTextInputTransformer label={"Projektnr."} >
                  <GlassInputControl>
                     <input value={Journalnr} onChange={(e) => setJournalnr(e.target.value)} type="text" />
                  </GlassInputControl>
               </GlassTextInputTransformer>
               <GlassTextInputTransformer label={"Antal Delnr."} >
                  <GlassInputControl>
                     <input value={delNrList.length} min={1} onChange={(e) => handleDelNrLength(parseInt(e.target.value))} type="number" />
                  </GlassInputControl>
               </GlassTextInputTransformer>
               {delNrList.length > 0 ? <GlassInputGroupTitle>Delnr.</GlassInputGroupTitle> : null}
               {/* <GlassInputGroupEscape> */}
               {delNrList.map((delNr, index) => (
                  <GlassTextInputTransformer key={index} label={""}>
                     <GlassInputControl>
                        <input value={delNr.nr} onChange={(e) => {
                           const newDelNrList = [...delNrList];
                           newDelNrList[index].nr = removeNothing(e.target.value) || "";
                           setDelNrList(newDelNrList);
                        }} placeholder="Delnr." style={{ flex: "auto", maxWidth: "8ex" }} />
                        <input value={delNr.areal} style={{ flex: "auto", textAlign: "end" }} onChange={(e) => {
                           const newDelNrList = [...delNrList];
                           newDelNrList[index].areal = removeButNumbers(e.target.value) || "";
                           setDelNrList(newDelNrList);
                        }} placeholder="Areal" />
                        <span style={{ flex: "unset" }} className="suffix">m²</span>
                     </GlassInputControl>
                  </GlassTextInputTransformer>
               ))}
               {/* </GlassInputGroupEscape> */}

               <GlassInputGroupTitle>Data Indlæsning</GlassInputGroupTitle>
               <GlassTextInputTransformer label={""}>
                  <table>
                     <tbody>
                        {servitutter.length > 0 ? <>
                           <tr><td>Hentet d.</td><td style={{ paddingLeft: "10px", flex: 1 }} >{new Date().toLocaleDateString("da-DK")}</td></tr>
                           <tr><td>Antal servitutter</td><td style={{ paddingLeft: "10px", flex: 1 }} >{servitutter.length}</td></tr>
                        </> : null}
                        {ejendomsData?.length > 0 ? <>
                           <tr><td>Antal matrikler</td><td style={{ paddingLeft: "10px", flex: 1 }} >{ejendomsData.length}</td></tr>
                           <tr><td>Antal ejerlav</td><td style={{ paddingLeft: "10px", flex: 1 }} >{new Set(ejendomsData.map((e) => e.ejerlav)).size}</td></tr>
                        </> : null}
                     </tbody>
                  </table>
               </GlassTextInputTransformer>
               <label></label>
               <GlassButtonRow adjust="end" >
                  {loadingServitut ? <Spinner animation="border" size="sm" style={{ display: loadingServitut ? "inline-block" : "none" }} /> : null}
                  <GlassButton disabled={!bfeNr} onClick={() => {
                     setLoadingServitut(true);
                     hentDataOgServitutter(bfeNr);
                  }} >
                     Hent
                  </GlassButton>
                  <GlassButton style={{ marginRight: "5px" }} onClick={() => {
                     ActionTracker.track("ServitutErklaering", "ServitutErklaering", "ResetServitutter");
                     setServitutter([]);
                  }} >
                     Nulstil
                  </GlassButton>

               </GlassButtonRow>

               <GlassInputGroupTitle>Underskrift</GlassInputGroupTitle>
               <GlassTextInputTransformer label={"Navn"} >
                  <GlassInputControl>
                     <input type="text" value={Underskrift.navn} onChange={(e) => setUnderskrift({ ...Underskrift, navn: e.target.value })} placeholder="Fulde navn" />
                  </GlassInputControl>
               </GlassTextInputTransformer>
               <GlassTextInputTransformer label={"Titel"} >
                  <GlassInputControl>
                     <input type="text" value={Underskrift.title} onChange={(e) => setUnderskrift({ ...Underskrift, title: e.target.value })} placeholder="eg. Landindspektør" />
                  </GlassInputControl>
               </GlassTextInputTransformer>
               <GlassTextInputTransformer label={"Underskrift"} >
                  <GlassInputControl>
                     <input type="file" onChange={(e) => setUnderskrift({ ...Underskrift, underskrift: e.target.files?.[0] || null })} />
                  </GlassInputControl>
               </GlassTextInputTransformer>
            </GlassInputGroup>
         </ADModalBody>
         <ADModalFooter >
            <GlassButton
               disabled={ejendomsData?.length === 0 || servitutter?.length === 0 || delNrList?.length === 0}
               onClick={async () => {
                  ActionTracker.track("ServitutErklaering", "ServitutErklaering", "CreatePDFLandscape");
                  await handleOnButtonClick("landscape", Underskrift, servitutter, Journalnr, delNrList, ejendomsData).catch((err) => {
                     message.error("Fejl ved oprettelse af PDF: " + err);
                  });
               }} >
               Opret (Landskab)
            </GlassButton>
            <GlassButton
               disabled={ejendomsData?.length === 0 || servitutter?.length === 0 || delNrList?.length === 0}
               onClick={async () => {
                  ActionTracker.track("ServitutErklaering", "ServitutErklaering", "CreatePDFPortrait");
                  await handleOnButtonClick("portrait", Underskrift, servitutter, Journalnr, delNrList, ejendomsData).catch((err) => {
                     message.error("Fejl ved oprettelse af PDF: " + err);
                  });
               }} >
               Opret (Portræt)
            </GlassButton>
         </ADModalFooter>
      </AdvancedDragModal>
   );
}

type servitut = {
   dokumentId: string,
   revisionNummer: string,
   aktId?: string,
   aktAliasId?: string,
   tinglysningsDato: string,
   servitutType: string,
   prioritetNummer: string,
   tekster?: string[],
   tekstSummarisk?: string,
   dokumentFilnavn: string
}


async function handleOnButtonClick(pLayout: "landscape" | "portrait", Underskrift: { navn: string, title: string, underskrift: File | null }, servitutter: servitut[], Journalnr: string, delNrList: { nr: string, areal: string }[], ejendomsData: any,) {
   let UnderskriftFile = Underskrift.underskrift;
   if (Underskrift.underskrift == null) {
      createAndSavePdf(pLayout, servitutter as servitut[], { ...Underskrift, underskrift: null }, Journalnr, delNrList, ejendomsData)
      return
   }
   let reader = new FileReader();
   reader.onload = (event) => {
      let img = new Image();
      img.onload = () => {
         let newUnderskrift = { ...Underskrift, underskrift: img || null };
         createAndSavePdf(pLayout, servitutter as servitut[], newUnderskrift, Journalnr, delNrList, ejendomsData)
      }
      img.src = event.target?.result as string;
   }
   reader.readAsDataURL(UnderskriftFile as Blob);
}


async function createAndSavePdf(
   pLayout: "landscape" | "portrait",
   servitutter: servitut[],
   underskrift: {
      navn: string,
      title: string,
      underskrift: HTMLImageElement | null
   },
   journalnr: string,
   delNrList: { nr: string, areal: string }[],
   ejendomsInfo: any
) {
   console.log(ejendomsInfo);
   console.log(servitutter);
   let testServitutter: servitut[] = servitutter.length ? servitutter : [];

   let doc = new jsPDF({
      orientation: pLayout,
      unit: "mm",
      format: "a4",
   })

   let pageWidth = doc.internal.pageSize.width;
   let ilM = 10; //inlineMargin
   let ilW = pageWidth - 2 * ilM; //inlineWidth
   let blM = 8; //blockMargin

   doc.addImage("customerLogo/Molbak.png", "PNG", pageWidth - (ilM + 46), 6, 46, 13)
   doc.addFont(
      "ARIALN.TTF",
      "Arial Narrow",
      "normal"
   )
   doc.addFont(
      "ARIALNB.TTF",
      "Arial Narrow",
      "bold"
   )
   doc.addFont(
      "consola.ttf",
      "Consolas",
      "normal"
   )

   doc.setFontSize(7);
   doc.text("Servituterklæring - Mapit - vEP5", ilM, blM);
   doc.text("Projektnr.: " + journalnr, ilM, blM + 3.5);
   doc.text("Udskrevet: " + new Date().toLocaleDateString("da-DK", { month: "2-digit", day: "2-digit", year: "numeric" }), ilM, blM + 7);
   doc.text("BFE-nr.: " + ejendomsInfo[0]?.samletFastEjendomBFEnummer || "", ilM, blM + 10.5);

   doc.setFontSize(14);
   doc.setFont("Arial Narrow", "bold");
   doc.text("Servituterklæring", pageWidth / 2, 32, { align: "center", maxWidth: 200 });
   doc.setFontSize(12);
   doc.text("i henhold til tinglysningslovens § 21", pageWidth / 2, 38, { align: "center", maxWidth: 200 });

   doc.setFontSize(12);
   doc.setFont("Arial Narrow", "normal");

   let arealFormatter = Intl.NumberFormat("da-DK").format;

   let delNrListFormatted = delNrList.map((a) => `delnr. ${a.nr} (${arealFormatter(parseInt(a.areal))} m²)`).join(" og ");
   let matNrFormatted = ejendomsInfo.length;
   let ejerlavFormmatted = new Set(ejendomsInfo.map((a) => a.ejerlav)).size;
   let inkludeEjerlavskode = ` (${ejendomsInfo[0].ejerlavskode})`;

   let matEjerlavFormatted = ejerlavFormmatted > 1 ? `${ejendomsInfo[0].matnr} ${ejendomsInfo[1].ejerlav}${inkludeEjerlavskode} m.fl`
      : matNrFormatted > 1 ? `${ejendomsInfo[0].matnr} m.fl ${ejendomsInfo[0].ejerlav}${inkludeEjerlavskode}`
         : `${ejendomsInfo[0].matnr} ${ejendomsInfo[0].ejerlav}${inkludeEjerlavskode}`;


   let longBeskrivelse = `I anledning af matrikulær ændring på ${delNrListFormatted} af matr.nr. ${matEjerlavFormatted}, erklærer jeg følgende om de på ejendommen tinglyste servitutter, idet der henvises til tingbogen pr. ${new Date().toLocaleDateString("da-DK", { day: "numeric", month: "long", year: "numeric" })}.`;
   let height = (doc.getTextWidth(longBeskrivelse) / ilW) * 3.4
   doc.text(longBeskrivelse, pageWidth / 2, 52 - height / 2, { align: "center", maxWidth: ilW })

   TableHeader(doc, height + 52, delNrList.map((a) => "Delnr. " + a.nr))
   let y = height + 52 + 22
   for (let i = 0; i < testServitutter.length; i++) {
      let { height, nextpage } = TableLine(doc, y, delNrList.length, testServitutter[i]);
      if (nextpage) {
         doc.addPage();
         y = 5
         TableLine(doc, y, delNrList.length, testServitutter[i]);
      }
      y += height;
   }

   if (y > doc.internal.pageSize.height - 45) {
      doc.addPage();
      y = 15;
   }
   Legend(doc, y);
   y += 39;
   if (y > doc.internal.pageSize.height - 60) {
      doc.addPage();
      y = 15;
   }
   await Signatur(doc, y, {
      underskrift: underskrift.underskrift,
      navn: underskrift.navn,
      title: underskrift.title
   })

   addPageNumber(doc);
   doc.save("ServitutErklæring.pdf");
}

function addPageNumber(doc: jsPDF) {
   let pages = doc.getNumberOfPages()
   doc.setFont("Arial Narrow", "normal");
   doc.setFontSize(10);
   for (let i = 1; i <= pages; i++) {
      doc.setPage(i);
      const { height, width } = doc.internal.pageSize
      doc.text(`Side ${i} af ${pages}`, width - 10, height - 10, { align: "right" });
   }
}

function TableHeader(doc: jsPDF, y: number, headers: string[]) {
   let ilM = 10;
   // Todo missingText
   doc.rect(ilM, y, 7, 22)
   doc.setFont("Arial Narrow", "bold");
   doc.setFontSize(10);
   doc.text("Nr.", ilM + 7 / 2, y + 11, { align: "center", baseline: "middle", rotationDirection: 1 })
   doc.rect(ilM + 7, y, 73, 22)
   doc.text("Servitut", ilM + 7 + 73 / 2, y + 11, { align: "center", baseline: "middle" })
   let x = ilM + 80;
   doc.rect(x, y, doc.internal.pageSize.width - (x + ilM), 5)
   doc.text("Besvarelse", x + (doc.internal.pageSize.width - (x + ilM)) / 2, y + 2.5, { align: "center", baseline: "middle" })

   doc.setFont("Arial Narrow", "normal");
   doc.setFontSize(8);
   for (let i = 0; i < headers.length; i++) {
      doc.rect(x, y + 5, 7, 17)
      rotatedTextMiddle(doc, headers[i], x + 3.5, y + 5 + 8.5);
      x += 7
   }
   doc.rect(x, y + 5, 7, 17)
   rotatedTextMiddle(doc, "Restejendom", x + 3.5, y + 5 + 8.5);
   doc.setFillColor(217, 217, 217)
   doc.rect(x + 7, y + 5, 9, 17, "FD")
   doc.setFillColor(0, 0, 0, 0)

   rotatedTextMiddle(doc, "Kan ikke\nstedfæstes", x + 8 + 5, y + 5 + 8.5);


   let ww = doc.internal.pageSize.width - (x + 16 + ilM);
   doc.rect(x + 16, y + 5, ww, 17)
   doc.text("Bemærkninger", x + 16 + ww / 2, y + 5 + 8.5, { align: "center" })
}


function lineReturn(h: number, np: boolean): { height: number, nextpage: boolean } {
   return {
      height: h,
      nextpage: np
   }
}

function TableLine(doc: jsPDF, y: number, delnr: number, data: servitut): { height: number, nextpage: boolean } {
   let ilM = 10;

   let prioritetNummer = data.prioritetNummer || "";
   let numberRef = data.aktAliasId || data.aktId || "";
   let text = data.tekstSummarisk || data.tekster?.join(", ") || "";

   doc.setFontSize(9);
   doc.setFont("Consolas", "normal");
   let height = (Math.floor(doc.getTextWidth(text) / 55) + 2) * 4.3;
   if (height + y > doc.internal.pageSize.height - 20) {
      return lineReturn(height, true);
   }

   doc.rect(ilM, y, 7, height)
   doc.text(prioritetNummer, ilM + 3.5, y + height / 2, { align: "center", baseline: "middle" })

   doc.rect(ilM + 7, y, 73, height)
   doc.setFont("Consolas", "normal");

   function TingBogRecordNumber(a: string) {
      return a.replace(/(.{4})(.{2})(.{2})-()/, "$3.$2.$1-$4")
   }

   doc.text(TingBogRecordNumber(numberRef), ilM + 8, y + 3)
   doc.text(text, ilM + 8, y + 6.5, { maxWidth: 73 - 2 })
   doc.setFont("Arial Narrow", "normal");

   let x = 80 + ilM;
   for (let i = 0; i < delnr; i++) {
      checkBox(doc, x, y, 7, height)

      x += 7
   }
   checkBox(doc, x, y, 7, height)
   doc.setFillColor(217, 217, 217)
   checkBox(doc, x + 7, y, 9, height, "FD")
   doc.setFillColor(0, 0, 0, 0)

   let ww = doc.internal.pageSize.width - (x + 16 + ilM);
   doc.setFont("Arial Narrow", "normal");
   doc.setFontSize(9);
   bemærkningsField(doc, x + 16, y, ww, height)

   return lineReturn(height, false);
}

function checkBox(doc: jsPDF, x, y, w, h, style?) {
   doc.rect(x, y, w, h, style);
   let c1 = new AcroFormTextField();
   c1.x = x + .5;
   c1.y = y + .5;
   c1.width = w - 1;
   c1.height = h - 1;
   c1.fontSize = 18;
   c1.multiline = false;
   c1.fontStyle = "bold"
   c1.textAlign = "center"
   c1.comb = true;
   doc.addField(c1);
}

function bemærkningsField(doc: jsPDF, x: number, y: number, w: number, h: number, style?: any) {
   doc.rect(x, y, w, h, style);
   let c1 = new AcroFormTextField();
   c1.x = x + .5;
   c1.y = y + .5; // TODO: Problemer med bibliotek
   c1.multiline = true
   c1.color = "#ff0000" //color
   c1.maxFontSize = 9;
   c1.fontSize = 9;

   c1.width = w - 1;
   c1.height = h - 1;
   doc.addField(c1);
}

function rotatedTextMiddle(doc: jsPDF, text: string, x: number, y: number) {
   let fontSizeC = doc.getFontSize() * 0.40;
   let textLines = text.split("\n");
   if (textLines.length > 1) {
      let textHeight = fontSizeC
      let totalOffset = (textLines.length - 1) * (textHeight * 1.4);
      for (let i = 0; i < textLines.length; i++) {
         let lineOffset = i * (textHeight) * 1.4;
         let width = doc.getTextWidth(textLines[i]);
         doc.text(textLines[i], x + lineOffset + totalOffset / 2, y + width / 2, { angle: 90, align: "center" });
      }
   } else {
      let width = doc.getTextWidth(text);
      let textHeight = fontSizeC;
      doc.text(text, x + textHeight / 3, y + width / 2, { angle: 90 });
   }
}

function Legend(doc: jsPDF, y: number) {

   y += 4.5;

   let ilM = 10;
   doc.setFont("Arial Narrow", "bold");
   doc.setFontSize(12);

   doc.text("X", ilM + 3.5, y, { align: "center", baseline: "middle" });
   doc.text("M", ilM + 3.5, y + 4.5, { align: "center", baseline: "middle" });
   doc.text("R", ilM + 3.5, y + 9, { align: "center", baseline: "middle" });

   doc.setFont("Arial Narrow", "normal");
   doc.setFontSize(10);
   doc.text("Servitutterne vedrører alene de delnumre/restejendommen der er markeret.", ilM + 8, y, { baseline: "middle" });
   doc.text("Servitutten vedrører alene de delnumre/restejendommen der er markeret, og den er i forvejen lyst i modtagerejendommen.", ilM + 8, y + 4.5, { baseline: "middle" });
   doc.text("Redegørelse for placering af servitut, der ikke findes i akten. Her redegøres for, hvordan der kan ske udtalelse om,", ilM + 8, y + 9, { baseline: "middle" });
   doc.text("hvilket areal servitutten forpligter, selv om servituttens tekst ikke er læst", ilM + 8, y + 13, { baseline: "middle" });
}

async function Signatur(doc: jsPDF, y: number, underskrift: {
   navn: string,
   title: string,
   underskrift: HTMLImageElement | null
}) {

   let pW = doc.internal.pageSize.width;
   doc.text("Den " + new Date().toLocaleDateString("da-dk", {
      year: "numeric",
      month: "long",
      day: "numeric"
   }), pW / 2, y, { align: "center" })

   let img = underskrift.underskrift;
   let h = 14;
   let w = img ? img.width * (h / img.height) : 40;

   if (underskrift.underskrift) doc.addImage(await underskrift.underskrift as any, "PNG", pW / 2 - (w / 2), y + 2, w, h)

   doc.line(pW / 2 - 25, y + 16, pW / 2 + 25, y + 16);
   doc.text(underskrift.navn, pW / 2, y + 22, { align: "center" });
   doc.text(underskrift.title, pW / 2, y + 26, { align: "center" });
}

function removeNothing(input: string): string {
   return input.trimStart();
}

function removeButNumbers(input: string): string {
   return input.replace(/\D/g, "").replace(/^0+(?!$)/, ""); // Remove non-digit characters and leading zeros
}

function transFormToEjendomsData(data: BFELookupType, bfeNr?: string): { matnr: string, ejerlav: string }[] {
   let SFE = data.SamletFastEjendom.features.find((a) => {
      if (a.properties.virkningTil != undefined && a.properties.status !== "Gældende") {
         return false
      }
      return a.properties.BFEnummer === parseInt(bfeNr || "");
   });
   let jordstykker = SFE?.properties.jordstykke.filter((a) => {
      return a.properties.status === "Gældende"
   }).map((js: Jordstykke) => {
      return {
         matnr: js.properties.matrikelnummer,
         ejerlav: js.properties.ejerlavsnavn,
         ejerlavskode: js.properties.ejerlavskode,
         samletFastEjendomBFEnummer: js.properties.samletFastEjendomBFEnummer,
      };
   });

   return jordstykker ?? [];
}



type Centroide = {
   geometri: string;
   senesteSagLokalId: string;
   status: string;
};

type Fredskov = {
   fredskovsareal: any;
   omfang: any;
};

type Jordrente = {
   omfang: any;
};

type Klitfredning = {
   klitfredningsareal: any;
   omfang: any;
};

type Majoratsskov = {
   majoratsskovsnummer: any;
   omfang: any;
};

type Strandbeskyttelse = {
   omfang: any;
   strandbeskyttelsesareal: any;
};

type JordstykkeProperties = {
   arealberegningsmetode: string;
   arealbetegnelse: any;
   arealtype: any;
   brugsretsareal: boolean;
   centroide: Centroide[];
   delnummer: any;
   ejerlavskode: number;
   ejerlavsnavn: string;
   faelleslod: boolean;
   forretningshaendelse: string;
   sekundaerForretningshaendelse: any[];
   forretningsomraade: string;
   forretningsproces: string;
   fredskov: Fredskov;
   id_lokalId: string;
   id_namespace: string;
   jordrente: Jordrente;
   klitfredning: Klitfredning;
   kommuneLokalId: string;
   majoratsskov: Majoratsskov;
   matrikelnummer: string;
   paataenktHandling: any;
   regionLokalId: string;
   registreretAreal: number;
   registreringFra: string;
   registreringTil: any;
   registreringsaktoer: string;
   samletFastEjendomBFEnummer: number;
   senesteSagLokalId: string;
   skelforretningssagsLokalId: any;
   sognLokalId: string;
   stammerFraJordstykkeLokalId: string;
   status: string;
   stormfald: any[];
   strandbeskyttelse: Strandbeskyttelse;
   supplerendeMaalingSagLokalId: any;
   vandarealinkludering: string;
   vejareal: number;
   vejarealberegningsstatus: string;
   virkningFra: string;
   virkningTil: any;
   virkningsaktoer: string;
};

type Jordstykke = {
   type: "Jordstykke";
   properties: JordstykkeProperties;
};

type SamletFastEjendomProperties = {
   BFEnummer: number;
   arbejderbolig: boolean;
   bygningPaaFremmedGrund: any[];
   ejerlejlighed: any[];
   erFaelleslod: boolean;
   forretningshaendelse: string;
   sekundaerForretningshaendelse: any[];
   forretningsomraade: string;
   forretningsproces: string;
   hovedejendomOpdeltIEjerlejligheder: boolean;
   id_lokalId: string;
   id_namespace: string;
   jordstykke: Jordstykke[];
   landbrugsnotering: any;
   paataenktHandling: any;
   registreringFra: string;
   registreringTil: any;
   registreringsaktoer: string;
   senesteSagLokalId: string;
   status: string;
   udskiltVej: boolean;
   virkningFra: string;
   virkningTil: any;
   virkningsaktoer: string;
};

type SamletFastEjendomFeature = {
   type: "Feature";
   properties: SamletFastEjendomProperties;
};

type FeatureCollection<T> = {
   type: "FeatureCollection";
   features: T[];
};

type BygningPaaFremmedGrundType = {
   BygningPaaFremmedGrundFlade: FeatureCollection<any>;
   BygningPaaFremmedGrundPunkt: FeatureCollection<any>;
};

type BFELookupType = {
   SamletFastEjendom: FeatureCollection<SamletFastEjendomFeature>;
   Ejerlejlighed: FeatureCollection<any>;
   BygningPaaFremmedGrund: BygningPaaFremmedGrundType;
};